export const QA_CONNECT_INJECTED_WALLET_EVENT = 'cowswap-connect-injected-wallet'
export const QA_FORCE_ONCHAIN_APPROVAL_SESSION_KEY = 'cowswap:qaForceOnchainApproval:v0'
